import { endpoints } from '../../Constants';
// eslint-disable-next-line object-curly-newline
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const subscriptionServices = {
	gateway,
};

function gateway({ req, method }) {
	switch (method) {
		case 'VIEW':
			return viewSubscription({
				req,
			});
		case 'LIST':
			return listSubscription({
				req,
			});
		case 'UPDATE':
			return updateSubscription({
				req,
			});
		case 'ENABLE':
			return toggleDisableSubscription({
				req,
			});
		default:
			break;
	}
	return new Promise();
}

function updateSubscription({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.UPDATE_SUBSCRIPTION, params);

	const requestOptions = {
		method: 'PUT',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function viewSubscription({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.PRODUCT_VARIANTS, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function listSubscription({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.ALL_PRODUCTS, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function toggleDisableSubscription({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.ALL_PRODUCTS, params);

	const requestOptions = {
		method: 'PATCH',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

export default subscriptionServices;
